export class ListToolbarSetExistsAction {
  constructor(public exists: boolean) {}
}
